import { stitchDark, stitchLight, ThemeMode, useThemeMode } from './index';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material';
import { StylesProvider } from '@mui/styles';

export const stitchThemeModeKey = 'stitchThemeMode';

export interface AppThemeProps {
    /**
     * Select the theme mode: 'light', 'dark', or 'system'
     * Defaults to 'system' (which defaults to 'light' if not detectable)
     */
    readonly themeMode: ThemeMode;

    /**
     * Children of the component
     */
    readonly children?: React.ReactNode;

    /**
     * add stylesprovider - lets us use the theme wrapper in multiple places
     */
    readonly stylesInject?: boolean;
}

export const AppTheme: React.FC<AppThemeProps> = ({ themeMode, children, stylesInject = false }) => {
    const actualTheme = useThemeMode(themeMode, stitchLight, stitchDark);

    return (
        <StylesProvider injectFirst={stylesInject}>
            <ThemeProvider theme={actualTheme}>
                <CssBaseline />
                {children}
            </ThemeProvider>
        </StylesProvider>
    );
};
